// import Vue from 'vue';

const LoadingOverlayPlugin = {
    install(Vue) {
        // `this.$loading` is a single shared singleton (see the mixin
        // below) — every component in the app calls show()/hide() on the
        // *same* object. Multiple call sites (List.vue alone has several)
        // can legitimately overlap, so overlay visibility must be
        // reference-counted: only create the DOM overlay on the first
        // show(), and only remove it once every outstanding show() has
        // been matched by a hide().
        //
        // Each show() returns a fresh, independent handle (not `this`)
        // specifically so that concurrent callers each get their own
        // `hide` closure. Returning the shared singleton itself here
        // would mean two overlapping `const loader = this.$loading.show()`
        // calls end up as the *same* object with a single mutable `hide`
        // property — whichever show() ran last silently owns the only
        // usable hide(), so an earlier caller's hide() can double-release
        // (or a later caller's can never fire).
        let activeCount = 0;
        let overlayEl = null;

        const loadingOverlay = {
            show() {
                activeCount += 1;

                if (!overlayEl) {
                    overlayEl = document.createElement('div');
                    overlayEl.className = 'loading-overlay';
                    overlayEl.innerHTML = `
          <div class="loading-spinner">
            <svg viewBox="25 25 50 50" class="spinner">
              <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
            </svg>
          </div>
        `;
                    document.body.appendChild(overlayEl);
                }

                let released = false;

                return {
                    hide() {
                        // Guard against this specific handle's hide()
                        // being called more than once (e.g. both a
                        // .then() and a .finally() releasing the same
                        // show()).
                        if (released) {
                            return;
                        }
                        released = true;

                        activeCount = Math.max(0, activeCount - 1);

                        if (activeCount === 0 && overlayEl) {
                            overlayEl.remove();
                            overlayEl = null;
                        }
                    },
                };
            },
        };

        // NOTE: `Vue.prototype.$loading = ...` (the Vue 2 idiom) does not
        // propagate to component instances under @vue/compat — verified
        // by regression test. A global mixin's beforeCreate hook is the
        // compat-safe equivalent. See __tests__/eventhub-compat.test.js
        // for the same root cause in the global event bus.
        Vue.mixin({
            beforeCreate() {
                this.$loading = loadingOverlay;
            },
        });
    },
    version: '0.0.3',
};

export default LoadingOverlayPlugin;
